import React, { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";
import { fetchAllCourses } from "../api/courseApi";

const CourseList = ({ courseId, setCourseId, showLabel = true, assignAfterRender = true }) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getCourses = async () => {
      try {
        setLoading(true);
        setError(null);

        const coursesData = await fetchAllCourses(true);        if (Array.isArray(coursesData)) {
          setCourses(coursesData);
          // Set the first course ID if there is data and no course is currently selected
          if (coursesData.length > 0 && !courseId && assignAfterRender) {
            setCourseId(coursesData[0].course_id);
          }
        } else {
          setCourses([]);
          setError("Invalid course data received");
        }
      } catch (err) {
        console.error("Error loading courses:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getCourses();
  }, []);

  const handleCourseChange = (event) => {
    const value = event.target.value;
    const selectedId = value ? parseInt(value, 10) : "";
    setCourseId(selectedId);
  };

  return (
    <div className="w-full space-y-2">
      <label
        htmlFor="course-select"
        className={`block text-sm font-medium text-gray-700 ${
          !showLabel && "hidden"
        }`}
      >
        Select Course
      </label>

      {error && (
        <div className="p-3 text-sm bg-red-50 border border-red-200 rounded-md text-red-800">
          {error}
        </div>
      )}

      <div className="relative">
        {loading && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
          </div>
        )}

        <select
          id="course-select"
          value={courseId || ""}
          onChange={handleCourseChange}
          className={`
    block w-full pl-5 pr-3 py-2 border border-gray-300 rounded-md leading-5 
    bg-white placeholder-gray-500 focus:outline-none focus:ring-1 
    focus:ring-blue-500 focus:border-blue-500 sm:text-sm
    disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed
    ${error ? "border-red-300" : "border-gray-300"}
  `}
          disabled={loading && courses.length === 0}
          aria-busy={loading}
          aria-invalid={!!error}
        >
          <option value={null}>Select a course</option>
          {courses.map((course) => (
            <option key={course.course_id} value={course.course_id}>
              {course.title}
            </option>
          ))}
        </select>
      </div>

      {!loading && courses.length === 0 && !error && (
        <p className="text-sm text-gray-500">No courses available</p>
      )}
    </div>
  );
};

export default CourseList;
